import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBrowseFilledStyle0 = cosmosIconCss;

const CosmosIconBrowseFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBrowseFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2ae8beab660d909dc9827f756cac5d403b66b1c0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2d4b92015d280bc8692a9cbffbd21c30fcd61636', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'eace237ee05146093b0482450d0c268647b2b57e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-14a.5.5 0 0 0-.5-.5h-14Zm16 1.5h1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-1v-12ZM8.412 14.405a.594.594 0 0 1-.912-.502V9.097c0-.469.516-.753.912-.502l3.796 2.403a.594.594 0 0 1 0 1.004l-3.796 2.403Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBrowseFilledStyle0; }
}, [1, "cosmos-icon-browse-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-browse-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-browse-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBrowseFilled$1);
            }
            break;
    } });
}

const CosmosIconBrowseFilled = CosmosIconBrowseFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBrowseFilled, defineCustomElement };
